import React from 'react';
import Logo from '../Logo';
import styles from './Footer.module.css';

const Footer = () => {
  const contactInfo = [
    { icon: '📧', text: 'sales@analyticax.in' },
    { icon: '📞', text: '+91 9177300126' },
    { icon: '📍', text: 'WeWork Zenia, Thane, Mumbai' }
  ];

  return (
    <footer id="contact" className={styles.footer}>
      <div className={styles.footerContent}>
        <div className={styles.footerLogo}>
          <Logo variant="white" />
        </div>
        <p className={styles.footerText}>Ready to transform your business with data?</p>
        <div className={styles.contactInfo}>
          {contactInfo.map((info, index) => (
            <div key={index} className={styles.contactItem}>
              <span>{info.icon}</span>
              <span>{info.text}</span>
            </div>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
